/* eslint-disable */
// FIXME: enable linting
// all user-related interactions, including fiscal code updates
import * as Sentry from "@sentry/vue";
import ModalAlert from "@/components/patterns/ModalAlert"; // eslint-disable-line import/no-extraneous-dependencies
import utils from "@/components/mixins/utils"; // eslint-disable-line import/no-extraneous-dependencies
import User from "../../clients/user"; // eslint-disable-line import/no-extraneous-dependencies

const state = {
  user: { emails: [], schools: [] },
  localFiscalCode: "",
  isFCWrong: false,
  fiscalCodeError: false,
  localConfirmedData: true,
};

const getters = {
  user: moduleState => moduleState.user,
  fiscalCodeError: moduleState => moduleState.fiscalCodeError,
  localFiscalCode: moduleState => moduleState.localFiscalCode,
  isFCWrong: moduleState => moduleState.isFCWrong,
  fiscalCode: moduleState => moduleState.localFiscalCode,
  localConfirmedData: moduleState => moduleState.localConfirmedData,
};

const actions = {
  async fetchUser({ commit, rootState }, force) {
    try {
      const user = await User.getUser(rootState.config, force);
      commit("setUser", user);
    } catch (e) {
      if (e.response && e.response.status === 403) utils.redirectToLogin(null, rootState.config);
      else {
        ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
      }
    }
  },
  setLocalFiscalCode({ commit }, fiscalCode) {
    /*
    this set the validated fiscal code when the blur event on the input field is fired
    to save the state, `storeFiscalCode` is required
    */
    commit("setLocalFiscalCode", fiscalCode);
  },
  async storeFCOnly({ commit, state, rootState }) {
    try {
      const user = await User.setFiscalCode(rootState.config, state.localFiscalCode);
      if (user) {
        commit("setUser", user);
      }
    } catch (e) {
      commit("setFiscalCodeError", true);
    }
  },
  async storeFiscalCode({ commit, state, rootState }) {
    try {
      const user = await User.setFiscalCode(rootState.config, state.localFiscalCode);
      if (user) {
        commit("setUser", user);
        commit("setOrderState", rootState.config.states.Laboratories);
        commit("setConfirmedData", true);
      }
    } catch (e) {
      commit("setFiscalCodeError", true);
    }
  },
  async savePrivacySettings({ commit, rootState }, payload) {
    try {
      await User.modifyUserEntities(rootState.config, payload.userId, payload.userChanges);
    } catch (e) {
      Sentry.captureException(e);
    }
  },
  async saveActivities({ dispatch, commit, rootState }, payload) {
    try {
      await User.modifyUserEntities(rootState.config, payload.userId, payload.userChanges);
    } catch (e) {
      Sentry.captureException(e);
    }
  },
  confirmData({ dispatch }) {
    dispatch("storeOrderConfirmedData", true);
  },
  resetConfirmationData({ commit, dispatch }) {
    commit("resetLocalConfirmedData", false);
    dispatch("storeOrderResetConfirmation", false);
  },
};

const mutations = {
  setFiscalCodeError: (oldState, fiscalCodeError) => (oldState.fiscalCodeError = fiscalCodeError),
  setUser: (oldState, user, userHeaderUpdate = true) => {
    oldState.user = user;
  },
  setFiscalCode: (oldState, cf) => (oldState.user.cf = cf),
  setLocalFiscalCode: (oldState, cf) => (oldState.localFiscalCode = cf),
  setFCCheck: (oldState, FCCheck) => (oldState.isFCWrong = FCCheck),
  setConfirmedData: (oldState, confirmation) => (oldState.user.confirmed_data = confirmation),
  resetConfirmedData: (oldState, reset) => (oldState.user.confirmed_data = reset),
  resetLocalConfirmedData: (oldState, reset) => (oldState.localConfirmedData = reset),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
